<div class="tagline">
  Find holistic health practitioners and <br> therapists online or in-person.
</div>

<div class="sub-tagline">
  First time users get <b>1 free private yoga class</b> with their first booking! *Limited time offer
</div>

<!---------------------- Start of Desktop view ---------------------->
<div class="card" *ngIf="currentWindowWidth > 1000">
  <div class="card-body">
    <form [formGroup]="searchForm" (ngSubmit)="onSubmit()" class="d-flex flex-fill align-items-center">
      <div class="search-container d-flex flex-fill">
        <div class="row d-flex flex-fill">
          <div class="col-md-auto d-flex flex-fill my-auto align-items-center">
            <img class="search-icon"  style="margin-top: 2px;" src="../../../assets/images/search.svg" alt="search">
            <input type="text" class="search-input flex-fill" formControlName="query" i18n-placeholder="search|Placeholder text in search bar" placeholder="Specialty, issue, practitioner name">
          </div>
          <div class="col-md-3 d-flex flex-fill border-left-box my-auto justify-content-center" style="align-items: center;">
            <img class="search-icon" src="../../../assets/images/location.svg" alt="location">
            <app-google-places
              class="flex-fill"
              [removeStyle]="true"
              (setAddress)="getAddress($event)"
              addressType="geocode"
              i18n-placeholder="search|Placeholder text for inputting zip code or city name"
              placeholder="Zip code or city"
              controlName="location"></app-google-places>
          </div>
          <div class="col-md-2 d-flex flex-fill border-left-box my-auto justify-content-center" style="align-items: center;">
            <select id="languages" formControlName="language" class="search-input flex-fill">
              <option
                *ngFor="let language of languages; let i = index;"
                [value]="language"
                i18n="dropdown option|The dropdown where the user selects the language">
                { language, select, All languages {All languages} English {English} French {French} German {German} Spanish {Spanish} }</option>
            </select>
          </div>
        </div>
      </div>
      <div style="max-width: 132px;" class="ml-3">
        <button class="btn btn-primary search-button" type="submit" i18n="button|Button used to execute a search query.">Search</button>
      </div>
    </form>
  </div>
</div>
<!---------------------- End of Desktop view ---------------------->

<!---------------------- Start of Mobile view ---------------------->
<div *ngIf="currentWindowWidth <= 1000">
  <form [formGroup]="searchForm" (ngSubmit)="onSubmit()">
    <div class="card">
      <div class="card-body">
        <div class="search-container d-flex flex-fill align-items-center">
          <img class="search-icon"  style="margin-top: 2px;" src="../../../assets/images/search.svg" alt="search">
          <input type="text" class="search-input flex-fill" formControlName="query" i18n-placeholder="search|Placeholder text in search bar" placeholder="i.e. back pain, anxiety, nutrition, physiotherapy">
        </div>
        <div class="search-container d-flex flex-fill" style="margin-top: 10px;">
          <img class="search-icon" style="margin-top: 4px;" src="../../../assets/images/location.svg" alt="location">
          <app-google-places
            class="flex-fill"
            [removeStyle]="true"
            (setAddress)="getAddress($event)"
            addressType="geocode"
            i18n-placeholder="search|Placeholder text for inputting zip code or city name"
            placeholder="Zip code or city"
            controlName="location"></app-google-places>
        </div>
        <div class="search-container d-flex flex-fill" style="margin-top: 10px;">
          <img class="search-icon" src="../../../assets/images/chat-box.png" alt="language">
          <select id="languages" formControlName="language" class="search-input flex-fill">
            <option
              *ngFor="let language of languages; let i = index;"
              [value]="language"
              i18n="dropdown option|The dropdown where the user selects the language">
              { language, select, All languages {All languages} English {English} French {French} German {German} Spanish {Spanish} }</option>
          </select>
        </div>
        <button style="margin-top: 10px;" class="btn btn-primary search-button" type="submit" i18n="button|Button used to execute a search query.">Search</button>
      </div>
    </div>
  </form>
</div>
<!---------------------- End of Mobile view ---------------------->

<div class="zaya-form-help-text mt-3 pb-5">
  Not sure what to search for?<br>
  Type in your condition i.e. Back Pain, Chronic Fatigue, IBS, Trauma, Anxiety <br>
  Type in your therapy i.e. Acupuncture, Massage, Psychotherapy, Reflexology
</div>
